import script from "./SiteBannerEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteBannerEdit.vue?vue&type=script&setup=true&lang=js"

import "./SiteBannerEdit.vue?vue&type=style&index=0&id=d24ca0a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d24ca0a2"]])

export default __exports__